<template>
  <div class="sportResultsContainer">
    <v-row v-if="sportResultSelections">
      <v-col md="12">
        <v-toolbar class="mb-3" height="30px">
          <h4>{{ sportMarketName }}</h4>
        </v-toolbar>
        <v-btn
          small
          outlined
          v-for="selection in sportResultSelections"
          :key="selection.id"
          class="resultSelection"
        >
          {{ selection.name }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({ }),
  computed: {
    ...mapGetters(['getSportResultSelections']),
    sportResultSelections () {
      const selections = this.getSportResultSelections[0]?.selections.filter(selection => selection.status === 'Trading')
      return selections
    },
    sportMarketName () {
      const marketName = this.getSportResultSelections[0]?.name
      return marketName
    }
  }
}
</script>

<style>
  .sportResultsContainer {
    background-color: #fff;
    padding: 36px;
  }
  
  .resultSelection {
    margin-right: 12px;
    margin-bottom: 12px;
  }
</style>
